export class NetworkError extends Error {
  constructor(message = 'No Response', eventId) {
    super(message)
    this.name = 'networkError'
    this.status = 0
    this.eventId = eventId
    this.report = false
  }
}
